import script from "./FiltrosOrdemCompra.vue?vue&type=script&setup=true&lang=js"
export * from "./FiltrosOrdemCompra.vue?vue&type=script&setup=true&lang=js"

import "./FiltrosOrdemCompra.vue?vue&type=style&index=0&id=0ac84742&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ac84742"]])

export default __exports__